

import { useWorkplaceRequestTypes } from '@/hooks/useWorkplaceRequestTypes';
import { WPRequestFilterSelect, WPRequestFilterSelectOption } from '@/components/basic/WPRequestFilterSelect';

interface WorkplaceRequestTypeSelectProps {
  value?: string[] | null;
  onValueChange?: (value: string[] | null) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

export const WorkplaceRequestTypeSelect = ({
  value = [],
  onValueChange,
  placeholder = 'All Types',
  className = 'min-w-[140px] justify-between font-normal text-sm',
  disabled = false
}: WorkplaceRequestTypeSelectProps) => {
  const { allElements: workplaceRequestTypes, isFetching: isLoadingTypes } = useWorkplaceRequestTypes();
  
  const options: WPRequestFilterSelectOption[] = workplaceRequestTypes.map(type => ({
    label: type.name,
    value: type.id
  }));

  return (
    <WPRequestFilterSelect
      options={options}
      value={value}
      onValueChange={onValueChange}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      showSearch={true}
      searchPlaceholder="Search types..."
    />
  );
};
